module.exports = __webpack_public_path__ + "static/logo_new-1a8bd0870f0cd902af50d76eb45c3f2a.svg";